import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Forgot from "@/pages/Forgot";
import Reset from "@/pages/Reset";
import Privacy from "@/pages/Privacy";
import Legal from "@/pages/Legal";
import { PagoExito, PagoCancelado } from "@/pages/PaymentReturn";
import NotFound from "@/pages/NotFound";

import Overview from "@/pages/app/Overview";
import AnalysesList from "@/pages/app/AnalysesList";
import AnalysisNew from "@/pages/app/AnalysisNew";
import AnalysisDetail from "@/pages/app/AnalysisDetail";
import Neceser from "@/pages/app/Neceser";
import Resultado from "@/pages/app/Resultado";
import Account from "@/pages/app/Account";
import Ajustes from "@/pages/app/Ajustes";
import AdminUsers from "@/pages/app/AdminUsers";
import AdminEmails from "@/pages/app/AdminEmails";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/acceder" element={<Login />} />
                    <Route path="/crear-cuenta" element={<Register />} />
                    <Route path="/recuperar" element={<Forgot />} />
                    <Route path="/restablecer" element={<Reset />} />
                    <Route path="/privacidad" element={<Privacy />} />
                    <Route path="/legal" element={<Legal />} />
                    <Route path="/pago/exito" element={<PagoExito />} />
                    <Route path="/pago/cancelado" element={<PagoCancelado />} />

                    {/* Test público (sin menú lateral ni navegación privada): Landing -> test anónimo -> devolución -> registro */}
                    <Route
                        path="/test"
                        element={
                            <div style={{ minHeight: "100vh", background: "#FAF8F5" }}>
                                <div style={{ borderBottom: "1px solid #E9E3DC", background: "#fff" }}>
                                    <div className="mx-auto max-w-3xl px-5 py-5">
                                        <Link
                                            to="/"
                                            data-testid="public-test-brand"
                                            style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: "0.3em", fontSize: 20, color: "#2E2A27" }}
                                        >
                                            <span style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "#C9982F", marginRight: 10, verticalAlign: "middle" }} aria-hidden="true" />MYAVEREN
                                        </Link>
                                    </div>
                                </div>
                                <div className="px-5 py-10 md:py-14">
                                    <AnalysisNew />
                                </div>
                            </div>
                        }
                    />

                    <Route
                        path="/app"
                        element={
                            <ProtectedRoute>
                                <DashboardLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Overview />} />
                        <Route path="analisis" element={<AnalysesList />} />
                        <Route path="analisis/nuevo" element={<AnalysisNew />} />
                        <Route path="analisis/:id" element={<AnalysisDetail />} />
                        <Route path="neceser" element={<Neceser />} />
                        <Route path="resultado" element={<Resultado />} />
                        <Route path="cuenta" element={<Account />} />
                        <Route path="ajustes" element={<Ajustes />} />
                        <Route
                            path="admin/usuarios"
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminUsers />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="admin/correos"
                            element={
                                <ProtectedRoute adminOnly>
                                    <AdminEmails />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster position="top-center" richColors={false} />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
